// ------------
// Timezones ==
// ------------

export default Intl.supportedValuesOf('timeZone')
